const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export interface IntakePayload {
  nombre: string;
  medio_contacto: string;
  correo?: string;
  telefono?: string;
  tema_general: string;
  ubicacion_asunto: string;
  fecha_proxima?: string;
  descripcion?: string;
  urgencia: string;
  origen: string;
  acepta_privacidad: boolean;
}

export async function submitIntake(payload: IntakePayload): Promise<{ id: string }> {
  const res = await fetch(`${API}/intake-requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err: any = new Error(data?.detail?.message || data?.detail || "No pudimos registrar tu solicitud");
    err.fields = data?.detail?.errors || null;
    throw err;
  }
  return data;
}

export function trackEvent(type: string, meta: Record<string, unknown> = {}) {
  try {
    const body = JSON.stringify({ type, path: window.location.pathname, meta });
    if (typeof navigator !== "undefined" && "sendBeacon" in navigator) {
      navigator.sendBeacon(`${API}/events`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API}/events`, { method: "POST", body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* analítica best-effort, nunca bloquea la experiencia */
  }
}
